import { Login } from "./pages/Login";
import { general } from "./shared/general";
import { forms } from "./shared/forms";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Onboard } from "./pages/Onboard";

export const en = {
	pages: {
		login: Login,
		forgot_password: ForgotPassword,
		reset_password: ResetPassword,
		onboard: Onboard,
	},
	shared: {
		general,
		forms,
	},
};
